import Element from './element.svelte'
import Items from './items.svelte'
import Item from './item.svelte'
import Link from './link.svelte'
import Table from './table.svelte'

const Block = {
  Element,
  Items,
  Item,
  Link,
  Table,
}

export default Block
